<template>
    <div>
        <my-search 
        v-model="pgData" 
        @search="searchHandler"
        time-start-placeholder="支付时间早至"
        time-end-placeholder="支付时间晚至"
        >

            <el-form-item>
                <el-radio-group v-model="pgData.issh" @change="searchHandler">
                    <el-radio-button label="0">未开发票</el-radio-button>
                    <el-radio-button label="2">已开发票</el-radio-button>
                </el-radio-group>
            </el-form-item>

            <template slot="title">
                <el-form-item>
                    <el-input v-model="pgData.txtKey" placeholder="项目名称"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-input v-model="pgData.txtKey1" placeholder="投标人"></el-input>
                </el-form-item>
            </template>
            
            <template slot="btn">
                <el-button 
                type="warning" 
                icon="el-icon-download"
                @click="exportHandler"
                >
                    导出
                </el-button>
            </template>
        </my-search>

        <my-table :data="tableData" :height="tableHeight">
            <el-table-column label="订单信息" prop="bdname" min-width="220">
                <template slot-scope="scope">
                    <div class="table-info-row">
                        {{scope.row.zbproname}}
                    </div>
                    <div class="table-info-row">
                        【投标人】
                        {{scope.row.tbdwname}}
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="支付信息" prop="auditdate" min-width="220">
                <template slot-scope="scope">
                    <div class="table-info-row">
                        {{scope.row.auditdate}}
                    </div>
                    <div class="table-info-row">
                        【支付金额】
                        {{scope.row.orderssum}}
                    </div>
                </template>
            </el-table-column>
            
            <el-table-column label="开票信息" prop="auditdate" min-width="220">
                <template slot-scope="scope">
                    <div class="table-info-row">
                        {{scope.row.fptime}}
                    </div>
                    <div class="table-info-row">
                        {{checkInvoiceInMonth(scope.row)}}
                    </div>
                    <div class="table-info-row">
                        <my-tag v-if="~['1', '2'].indexOf(scope.row.fpbj)" type="success">已开票</my-tag>
                        <my-tag v-else type="warning">未开票</my-tag>
                    </div>
                </template>
            </el-table-column>
            
            
            <el-table-column label="操作" width="150" fixed="right">
                <template slot-scope="scope">
                    <my-btn 
                        v-if="~['1', '2'].indexOf(scope.row.fpbj)"
                        type="detail" 
                        @click="detailHandler({ddh: scope.row.orderscode})"
                    ></my-btn>
                </template>
            </el-table-column>
        </my-table>

        <my-pagination
            ref="page"
            v-model="tableData"
            :search="pgData"
            :action="`${getGetters('mngUrl')}/manage/finance/auditorder/getdzfplist.json`">
        </my-pagination>

    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'

export default {
    mixins: [ LIST_PAGE_MIXIN ],
    components: { },
    data() {
        return {
            pgData: {
                sortname: 'auditdate',
                sortorder: 'asc',

                issh: '2',
                txtKey3: '',
                txtKey: '',
                txtKey1: '',
            },
        }
    },
    computed: {
        
    },
    methods: {
        checkInvoiceInMonth(row) {
            if(!row.auditdate || !row.fptime) {
                return '非当月开票';
            } else {
                if(row.auditdate.slice(0, 7) === row.fptime.slice(0, 7)) {
                    return '当月开票';
                } else {
                    return '非当月开票';
                }
            }
        },
        exportHandler() {
            var search = window.toSearch(this.form);
            window.location.assign(`${this.getGetters('mngUrl')}/manage/finance/auditorder/export.json${search}`)
        }
    },
    created() {
        // this.jspInit(`${this.getGetters('mngUrl')}/manage/finance/auditorder/bdlist.json`, {
            
        // }, data => {
        //     this.jspDataInit(data, [
        //         'dwcode',
        //     ]);
        // });
    },
    mounted() {
        
    }
}
</script>

<style scoped lang="scss">
    .table-info-row + .table-info-row{margin-top:.5em;}
</style>
